import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import apiRoutes from '@/lib/apiRoutes';
import { opstechHttpClient } from '@/lib/httpClient';
import { featureToAddress } from '@/lib/utils';
import type { DefaultQueryError } from '../types';
import type { Address, GeocodeReverseData, LatLng } from './types';

export const getGeocodeReverseFn = async (params: LatLng) => {
  const response = await opstechHttpClient.get<GeocodeReverseData>(
    apiRoutes.place.geocode_reverse,
    {
      params: {
        profile: 'ahamove',
        'boundary.country': 'VN',
        'boundary.circle.radius': '2000',
        ...params,
      },
    }
  );
  return featureToAddress(response.data.data);
};

export const useGetGeocodeReverse = (
  params: LatLng,
  opts?: UseQueryOptions<Address | null, DefaultQueryError>
) =>
  useQuery<Address | null, DefaultQueryError>(
    [apiRoutes.place.geocode_reverse, params],
    () => getGeocodeReverseFn(params),
    opts
  );
